const resource = '/admin/v1/tools'

export default $axios => ({
  exportTemplate(payload) {
    return $axios.post(`${resource}/export-template`, payload)
  },
  exportData(payload) {
    return $axios.post(`${resource}/export-data`, payload)
  },
  exportApplication(payload) {
    return $axios.post(`${resource}/export-application`, payload)
  },
  getExportStatus(payload) {
    return $axios.post(`${resource}/get-export-status`, payload)
  },
  download(payload) {
    return $axios.post(`${resource}/download-zip-file`, payload, {
      responseType: 'blob',
    })
  },
  importData(payload) {
    return $axios.post(`${resource}/import-data`, payload, {
      'Content-Type': 'application/zip',
    })
  },
  confirmImport(payload) {
    return $axios.post(`${resource}/confirm-import`, payload)
  }
})
